"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessPeriodToJSON = exports.BusinessPeriodFromJSONTyped = exports.BusinessPeriodFromJSON = void 0;
function BusinessPeriodFromJSON(json) {
    return BusinessPeriodFromJSONTyped(json, false);
}
exports.BusinessPeriodFromJSON = BusinessPeriodFromJSON;
function BusinessPeriodFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'timeStart': json['timeStart'],
        'timeEnd': json['timeEnd'],
    };
}
exports.BusinessPeriodFromJSONTyped = BusinessPeriodFromJSONTyped;
function BusinessPeriodToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'timeStart': value.timeStart,
        'timeEnd': value.timeEnd,
    };
}
exports.BusinessPeriodToJSON = BusinessPeriodToJSON;
